import { apiClient } from '@/lib/api-client';

export type EnhanceOutcome =
  | { readonly kind: 'ok'; readonly dataUrl: string }
  | { readonly kind: 'unavailable' }
  | { readonly kind: 'failed' };

/**
 * «Migliora con IA» (#387, D19): sends one JPEG to the identity-documents service, which asks
 * Gemini (EU) for tone, light and sharpness only and stores nothing. The screen calls this only
 * after the user has read the notice and confirmed.
 */
export async function enhanceWithAi(jpegDataUrl: string): Promise<EnhanceOutcome> {
  const base64Data = jpegDataUrl.split(',')[1] ?? '';
  try {
    const { data, response } = await apiClient.POST('/v1/identity-documents/images/enhance', {
      body: { image: { mediaType: 'image/jpeg', base64Data } },
    });
    if (response.status === 503) return { kind: 'unavailable' };
    if (!response.ok || data === undefined) return { kind: 'failed' };
    return { kind: 'ok', dataUrl: `data:${data.image.mediaType};base64,${data.image.base64Data}` };
  } catch {
    return { kind: 'failed' };
  }
}
